import axiosClient from "./axiosClient";

const documentService = {
  create: (data) => axiosClient.post("/documents/", data),
  update: (docId, data) => axiosClient.put(`/documents/${docId}`, data),
  delete: (docId) => axiosClient.delete(`/documents/${docId}`),
  getByForm: (formId) => axiosClient.get(`/documents/form/${formId}`),
  getMyDocuments: (formId) => axiosClient.get(`/documents/my/${formId}`),
};

export default documentService;
